import { PersonAvatar } from "client/Components";
import { ReactElement } from "react";
import { UserIdentityModel, getUserProfileImageUrl } from "client/Api/UserProfile/service";
import { getComputedDisplayName } from "client/Features/AddressBook/common";

export type MobileCommentAvatarProps = {
	authorUserInfo: UserIdentityModel;
};

export const MobileCommentAvatar = (props: MobileCommentAvatarProps): ReactElement => {
	const {
		authorUserInfo
	} = props;

	const profileImageUrl: string | null = authorUserInfo.avatarId
		&& getUserProfileImageUrl(authorUserInfo.avatarId);

	const { initials } = getComputedDisplayName({
		firstName: authorUserInfo.firstName,
		lastName: authorUserInfo.lastName
	});

	return (
		<PersonAvatar
			trackingId="comment-avatar"
			size="small"
			initials={initials}
			imageSrc={profileImageUrl}
		/>
	);
};

MobileCommentAvatar.displayName = "MobileCommentAvatar";